module.exports = __webpack_public_path__ + "static/media/komma-rum-mobile-2.6eb5f632.png";